<template>
  <div class="container my-4">
    <h4 class="mt-3 mb-4 pb-4 border-bottom">Geräte</h4>
    <div class="row justify-content-start" v-if="isLoading === false">
      <DeviceCardComponent v-for="(device, index) in devices" :key="`device-${index}`" :device="device" />
    </div>
    <SpinnerComponent v-else />
  </div>
</template>

<script>
import DeviceCardComponent from '../components/DeviceCardComponent'
import SpinnerComponent from '../components/SpinnerComponent'

import { firestore } from "../plugins/firebase"
import { collection, query, orderBy, getDocs } from "firebase/firestore"

export default {
  name: 'DevicesView',
  components: {
    DeviceCardComponent,
    SpinnerComponent
  },
  mounted() {
    this.fetchDevices()
  },
  methods: {
    fetchDevices: async function () {

      const q = query(collection(firestore, 'devices'), orderBy("orderIndex", "asc"))

      await getDocs(q)
        .then((d) => {
          this.isLoading = false;
          d.forEach(document => {
            const device = {
              id: document.id,
              data: document.data()
            }
            this.devices.push(device)
          })
        })
        .catch(error => console.error(error)) // eslint-disable-line no-console


    }
  },
  data() {
    return {
      devices: [],
      isLoading: true
    }
  }
}
</script>